import Tooltip from 'core/components/dialogs/Tooltip'
import { PayPeriod } from 'types/pay-periods'
import { formatPayPeriodLabel } from 'utils/Functions'

interface Props {
  selectedPayPeriods: PayPeriod[]
}

const SelectedPayPeriodsBrief = ({ selectedPayPeriods }: Props) => {
  const firstPayPeriod = selectedPayPeriods[0]
  const total = selectedPayPeriods.length - 1

  if (selectedPayPeriods.length === 0) return null

  return (
    <>
      <span>{formatPayPeriodLabel(firstPayPeriod)}</span>
      {total > 0 && (
        <Tooltip
          dark
          position="bottom-middle"
          content={
            <div>
              <div>Selected pay periods:</div>
              <ul className="list-disc pl-7">
                {selectedPayPeriods.map((payPeriod) => (
                  <li key={payPeriod.id}>{formatPayPeriodLabel(payPeriod)}</li>
                ))}
              </ul>
            </div>
          }
        >
          <span className="ml-1 text-primary cursor-pointer inline-block bg-transparent">
            +{total}
          </span>
        </Tooltip>
      )}
    </>
  )
}

export default SelectedPayPeriodsBrief
